import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WifiIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M15.99 8.61c4.71 0 9.02 1.65 12.4 4.37.27.23.67.2.91-.06l1.53-1.68a.63.63 0 0 0-.06-.92C26.76 7.02 21.62 4.75 16 4.75c-5.63 0-10.75 2.27-14.76 5.56a.63.63 0 0 0-.06.92l1.52 1.69c.24.25.63.28.9.06A19.69 19.69 0 0 1 16 8.6Z"
      />
      <path
        fill="currentColor"
        d="M15.99 16.21c2.73 0 5.25.92 7.26 2.45.28.2.67.19.9-.07l1.68-1.84a.63.63 0 0 0-.07-.92 15.8 15.8 0 0 0-9.77-3.47c-3.7 0-7.08 1.35-9.76 3.47a.63.63 0 0 0-.07.91l1.67 1.84c.24.26.62.28.9.07A12 12 0 0 1 16 16.21h-.01Zm4.73 6.14a.63.63 0 0 0-.1-.95 8.08 8.08 0 0 0-4.64-1.53c-1.73 0-3.32.6-4.64 1.53a.64.64 0 0 0-.11.95l4.26 4.69c.26.28.71.28.97 0l4.26-4.7Z"
      />
    </BaseIcon>
  );
}
